// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2-40Y","header":"PatientQuestionnaire_header__2Nmty","info":"PatientQuestionnaire_info__7pcG8"};